import React, { useRef, useState, useEffect } from 'react';
import { useOutsideHandler } from '@growth/custom-hooks/useOutsideHandler';
import { _ as _taggedTemplateLiteralLoose } from '../../../../dist/taggedTemplateLiteralLoose-7a042257.esm.js';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var SelectFldWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\twidth: ", ";\n\tposition: relative;\n"])), function (props) {
  return props.width ? props.width : '';
});
var SelectElement = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 58px;\n\tpadding: 18px 14px;\n\tfont-weight: 700;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #141823;\n\tborder: 1px solid rgba(0, 0, 0, 0.12);\n\tborder-radius: 4px;\n\tposition: relative;\n\tcursor: pointer;\n\t", "\n\t&::after {\n\t\tcontent: '';\n\t\tborder: solid #647a97;\n\t\tdisplay: inline-flex;\n\t\tborder-width: 0 2px 2px 0;\n\t\tpadding: 4px;\n\t\ttransform: rotate(45deg);\n\t\tposition: absolute;\n\t\tright: 17px;\n\t\ttop: 22px;\n\t}\n"])), function (p) {
  return p.isActive && "\n    border-color: #2276E3;\n  ";
});
var SelectLabel = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tleft: 18px;\n\ttop: 19px;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #777777;\n\tfont-weight: 700;\n\ttransition: all 0.3s ease-in-out;\n\t", "\n"])), function (p) {
  return p.isSelected && "\n    left: 14px;\n    top: -11px;\n    font-size: 12px;\n    font-weight: 400;\n    background: #fff;\n    padding: 0 4px;\n  ";
});
var SelectedOption = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #141823;\n\tfont-weight: 700;\n"])));
var OptionList = styled.ul(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tbackground-color: #fff;\n\tbox-shadow: 0 0 7px rgba(0, 0, 0, 0.2);\n\tpadding: 10px 18px;\n\tborder-radius: 4px;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 58px;\n\tz-index: 2;\n\tmax-height: 200px;\n\toverflow-y: auto;\n"])));
var OptionItem = styled.li(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #000;\n\tfont-weight: 700;\n\tcursor: pointer;\n\tpadding: 8px 0;\n"])));

var DropDown = function DropDown(_ref) {
  var labelText = _ref.labelText,
    width = _ref.width,
    options = _ref.options,
    _ref$selectedValue = _ref.selectedValue,
    selectedValue = _ref$selectedValue === void 0 ? '' : _ref$selectedValue,
    handleOptionSelected = _ref.handleOptionSelected;
  var optionRef = useRef();
  var _useState = useState(false),
    toggle = _useState[0],
    setToggle = _useState[1];
  var _useState2 = useState(selectedValue),
    selectedVal = _useState2[0],
    setSelectedVal = _useState2[1];
  useEffect(function () {
    setSelectedVal(selectedValue);
  }, [selectedValue]);
  var toggleDropdown = function toggleDropdown(e) {
    e.stopPropagation();
    e.preventDefault();
    setToggle(function (value) {
      return !value;
    });
  };
  var onOptionSelect = function onOptionSelect(opt) {
    setSelectedVal(opt.name);
    setToggle(false);
    if (handleOptionSelected) handleOptionSelected(opt);
  };
  useOutsideHandler({
    eventName: 'click',
    ref: optionRef,
    callback: function callback() {
      if (toggle) setToggle(false);
    }
  });
  return /*#__PURE__*/React.createElement(SelectFldWrap, {
    width: width,
    ref: optionRef
  }, /*#__PURE__*/React.createElement(SelectElement, {
    onClick: toggleDropdown,
    isActive: toggle
  }, labelText && /*#__PURE__*/React.createElement(SelectLabel, {
    isSelected: selectedVal
  }, labelText), selectedVal && /*#__PURE__*/React.createElement(SelectedOption, null, selectedVal)), options && options.length > 0 && toggle && /*#__PURE__*/React.createElement(OptionList, null, options.map(function (item) {
    return /*#__PURE__*/React.createElement(OptionItem, {
      key: item.id,
      onClick: function onClick(e) {
        e.stopPropagation();
        onOptionSelect({
          name: item.name,
          id: item.id
        });
      }
    }, item == null ? void 0 : item.name);
  })));
};

export { DropDown };
